import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const GalleryVerticalEnd: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M7 2h10' }],
    ['path', { d: 'M5 6h14' }],
    ['rect', { width: '18', height: '12', x: '3', y: '10', rx: '2' }],
  ],
];

export default GalleryVerticalEnd;
